// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"c8f551ce","341":"3e675efa","404":"40a8dd57","453":"24fe933f","464":"a9a7e8de","695":"081a79ad"}[chunkId] + ".chunk.js";
};